import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { GridFilterModel } from '@mui/x-data-grid';
import keyBy from 'lodash/keyBy';

import { FacilityType } from '../../../services/admin';
import { buildApiFiltersFactory } from './utils/api-filters-factory';
import {
  buildInitialFiltersFactory,
  FILTER_STORAGE_KEY,
} from './utils/initial-filters-factory';

export const useFiltersModel = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filterModel, setFilterModel] = useState<GridFilterModel>(() => {
    return {
      items: buildInitialFiltersFactory(searchParams, {
        fromUrl: searchParams.size > 0,
        fromSession: searchParams.size === 0,
      })
        .addStringFilter('facilityName', 'facilityName')
        .addBooleanFilter('addedToSaas', 'onboarded')
        .addBooleanFilter('isUsingMobile', 'usingMobile')
        .addBooleanFilter(
          'isUsingSaasAuthentication',
          'usingSaaSAuthentication'
        )
        .addBooleanFilter('isUsingSbvPro', 'usingSbvPro')
        .build(),
    };
  });

  const apiFilters = useMemo(() => {
    const mapped = keyBy(filterModel.items, 'field') as unknown as Record<
      keyof FacilityType,
      {
        value: any;
      }
    >;
    return buildApiFiltersFactory()
      .appendIfDefined('filter', mapped.facilityName?.value)
      .appendIfDefined('addedToSaas', mapped.onboarded?.value)
      .appendIfDefined(
        'isUsingSaasAuthentication',
        mapped.usingSaaSAuthentication?.value
      )
      .appendIfDefined('isUsingMobile', mapped.usingMobile?.value)
      .appendIfDefined('isUsingSbvPro', mapped.usingSbvPro?.value)
      .build();
  }, [filterModel.items]);

  useEffect(() => {
    setSearchParams({});
  }, [setSearchParams]);

  useEffect(() => {
    sessionStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(filterModel));
  }, [filterModel]);

  return {
    filterModel,
    setFilterModel,
    apiFilters,
  };
};
